import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Modal from 'components/Modal/Modal';
import { IRO_QUESTION_TYPES } from 'constants/materialAssessment';
import useMAIROQuestionsForm from 'pages/MaterialAssessmentPages/MaterialAssessmentIRO/hooks/useMAIROQuestionsForm';

import MAIROQuestionRate from './components/MAIROQuestionRate';
import MAIROQuestionSelect from './components/MAIROQuestionSelect';
import MAIROQuestionSwitcher from './components/MAIROQuestionSwitcher';

import type IDetailsModal from './intefaces/IDetailsModal';

import styles from './scss/DetailsModal.module.scss';

function DetailsModal({
  open, handleCancelModal, details, title,
}: IDetailsModal) {
  const { t } = useTranslation();
  const {
    control,
    setValue,
  } = useMAIROQuestionsForm();
  const fields = useWatch({ control });

  useEffect(() => {
    if (details && details.questions.length > 0) {
      details.questions.forEach((question, index) => {
        if (question.questionType === IRO_QUESTION_TYPES.RATE) {
          const answer = question?.answer[0]?.rate;
          setValue(`questions.${index}.answer.rate` as const, answer);
        } else {
          const answer = question?.answer[0]?.selectedOptionId;
          setValue(`questions.${index}.answer.selectedOptionId` as const, answer);
        }
      });
    }
  }, [details, setValue]);

  return (
    <Modal
      open={open}
      title={title || ''}
      className={styles.modalContainer}
      isButtonsVisible={false}
      onClose={handleCancelModal}
    >
      <div className={clsx(styles.root)}>
        {details?.questions?.map((question, index) => {
          const questionsData = fields?.questions || [];
          const questionsLength = questionsData.length || 0;

          const currentValue = (index >= 0 && questionsLength > 0)
            ? questionsData[index]?.answer?.selectedOptionId : undefined;

          return (
            <div
              className={styles.contentWrapper}
              key={[question.id, question.name].join('_')}
            >
              {question.questionType === IRO_QUESTION_TYPES.SWITCH && (
                <MAIROQuestionSwitcher
                  key={question.id}
                  question={question}
                  control={control}
                  setValue={setValue}
                  questionIndex={index}
                  currentValue={currentValue}
                  disabled
                />
              )}
              {question.questionType === IRO_QUESTION_TYPES.SELECT && (
                <MAIROQuestionSelect
                  key={question.id}
                  question={question}
                  control={control}
                  setValue={setValue}
                  questionIndex={index}
                  currentValue={currentValue}
                  disabled
                />
              )}
              {question.questionType === IRO_QUESTION_TYPES.RATE && (
                <MAIROQuestionRate
                  key={question.id}
                  question={question}
                  control={control}
                  setValue={setValue}
                  questionIndex={index}
                  currentValue={currentValue}
                  disabled
                />
              )}
            </div>
          );
        })}
        <div className={styles.commentsWrapper}>
          <p className={styles.commentsTitle}>
            {t('materialityAssessment.comments')}
            :
          </p>
          <p className={styles.commentsText}>{details?.comment || t('materialityAssessment.noComments')}</p>
        </div>
      </div>
    </Modal>
  );
}

export default DetailsModal;
